import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs, Base_url_api_live } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";
import leave from "../component/leave.json";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Inlogo, Bbpsasured, xopaylogo2, susimg, fineimg } from '../component/image';
import Producr from "../component/Product";

let UserRent_copy = () => { 
 
  let [data, setData] = useState();
  let [datae, setDatae] = useState()
  let [indexs, setIndex] = useState(0);
  let [count, setCount] = useState();

  let [pikk, setPikk] = useState(false);

  let [selas, setSelas] = useState();
  let [allsselas, setallSelas] = useState();
  let [allsselasdata, setallSelasdata] = useState();
  let [sel, setSel] = useState("All");

  let [selkd, setSelkd] = useState("All");
  let [selkdone, setSelkdone] = useState("All");

  let [selsame, setSelsame] = useState("All");

  let [charge, setCharge] = useState();

  let [datadd, setDatadd] = useState(false);
  let [charggges, setChsrggess] = useState();

  let [ff, setFF] = useState();

  let [sms, setSms] = useState([]);
  let [prepaidfees, setPrepaidfees] = useState();

  let [pg_res, Setpg_res] = useState();

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  const [text, setText] = useState("");
  const [htmlString, sethtmlString] = useState("");

  let [showrefund, setShowrefund] = useState(false);
  const contentRef = useRef();

  useEffect(() => {
    Start();
    User();
    Getleave()
    let one = htmlString.replace('inlogo', xopaylogo2);
    let two = one.replace('Inlogo', Inlogo);

    let three = two.replace('susimg', susimg);
    let four = three.replace('Bbpsasured', Bbpsasured);
    sethtmlString(four)
  }, []);

  useEffect(() => {
    Filter();
  }, [sel]);

  useEffect(() => {
    searchssnew();

  }, [selsame]);

  let update = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, id: ff._id, change: selas };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/rentupdate", 
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          if (Jsson.status === true) {

            // setData(Jsson.data);
            window.location.reload();
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let Filter = async () => {
    if (sel === "All") {
      User();
    } else {
      setIndex(0);

      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: 10,
          skip: 0,
          search: true,
          payment_status_msg: sel,
          newpayment : true
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rent",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);


            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let Getleave = async () => {
    try {
      let token = await localStorage.getItem("token");
      if (token === undefined || token === null || token === "") {
        navigate("/login");
        return;
      }

      let apicall = await axios({
        method: "get",
        url: Base_url_api_live + '/admin2/getleave',
      })
        .then((dat) => {

          console.log(dat.data.data, 'jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj');
        })
        .catch((ee) => {

        });
    } catch (err) {

    }
  }

  let User = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: 0 , newpayment : true };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/rent",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, 'Jsson kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk')

          if (Jsson.status === true) {
            setallSelas(Jsson.selectdata)
            setData(Jsson.data);
            setCount(Jsson.count);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let ClickCat = (re) => {

    navigate("/category", { state: re });
  };

  function convertAndFormatTimestamp(timestamp, targetTimezone = "en-US") {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short",
    };

    return date.toLocaleString(targetTimezone, options);
  }

  const handlePageClick = async (event) => {
    setIndex(event.selected);
    if (datadd === true) {
      searchssnews(event.selected, 10);
      return;
    }

    if (sel === "All") {
      try {
        let token = await localStorage.getItem("token");

        let pp = { token, limit: 10, skip: event.selected , newpayment : true };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rent",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);

            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    } else {
      let token = await localStorage.getItem("token");

      let pp = {
        token,
        limit: 10,
        skip: event.selected,
        search: true,
        payment_status_msg: sel,
        newpayment : true
      };

      try {
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rent",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);


            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  function convertDateString(dateString) {
    const now = new Date(dateString);

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  let fffff = (datesss) => {

    const date = new Date(datesss);

    // Format the date and time
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Pad the minutes and seconds with leading zeros if necessary
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

    // Create the formatted date string
    const formattedDate = `${day}-${month}-${year} ${hours}:${formattedMinutes}:${formattedSeconds}`;



    return formattedDate;
  };

  let ggfg = async () => {
    const decimalNumber = bigInt(
      "0x" + "9e672f013b1352d02bd506ad91cf58633cd8b3765686151bd53eeb2e4b3ae86f"
    ).toString(10);
    return decimalNumber;
  };

  let [ones, setones] = useState(0);
  let [twos, settwos] = useState(0);
  let [threes, setthrees] = useState(0);
  let [fouers, setfouers] = useState(0);

  let searchssnews = async (page, limit) => {
    if (selsame === "All") {
      User();
    } else {
      setIndex(page);

      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: limit,
          skip: page,
          searchnew: true,
          payment_status_msg: sel,
          searchnewdata: selsame,
          newpayment : true
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rent",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);


            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  let searchssnew = async () => {
    if (selsame === "All") {
      User();
    } else {
      setIndex(0);

      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: 10,
          skip: 0,
          searchnew: true,
          payment_status_msg: sel,
          searchnewdata: selsame,
          newpayment : true
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url + "/admin/rent",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);


            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => { });
      } catch (err) { }
    }
  };

  let searchss = async () => {

    if (value === "" || value === undefined || value === null) {
      User();
      return;
    }
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: 0, searchs: value };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/rentsearch",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            setData(Jsson.data);
            setCount(Jsson.count);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  function addWorkingDay(count, dat, leave) {
    // Parse the input date string
    const date = new Date(dat);

    // Initialize the count of days to add
    let addedDays = 0;

    // Helper to format date for comparison
    const formatDate = (d) =>
      d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    // Loop until we've added the required number of working days
    while (addedDays < count) {
      date.setDate(date.getDate() + 1); // Add 1 day

      // Check if the day is not Sunday and not in the leave array
      if (date.getDay() !== 0 && !leave.includes(formatDate(date))) {
        addedDays++;
      }
    }

    // Format the final date
    const formattedDate = formatDate(date);

    // Format the time
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });

    // Concatenate date and time in the desired format
    const formattedDateTime = `${formattedDate}`;

    return formattedDateTime;
  }

  let verifyy = async (tt) => {

    try {
      let token = await localStorage.getItem("token");
      let pp = { token, verify: tt.verified, pdid: tt._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/verifyadd",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, verified: true } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, verified: true });
              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, verified: false } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, verified: false });
              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let Freeze = async (tt) => {

    try {
      let token = await localStorage.getItem("token");
      let pp = { token, verify: tt.freeze, pdid: tt._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/freezeadd",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, freeze: true } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, freeze: true });
              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, freeze: false } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, freeze: false });
              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  function newaddWorkingDay(count, twoo, date) {
    let currentDate = new Date(date); // Start with today's date
    let daysAdded = 0; // Keep track of how many valid days we've added

    // Helper function to check if the current date is in the 'twoo' array
    function isInTwoo(date) {
      let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
      return twoo.includes(dateStr);
    }

    while (daysAdded < count) {
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday
      let dayOfMonth = currentDate.getDate(); // Get the day of the month

      // Skip Sundays
      if (dayOfWeek === 0) {
        continue;
      }

      // Skip 2nd, 4th, and 5th Saturdays
      if (dayOfWeek === 6) {
        let weekOfMonth = Math.ceil(dayOfMonth / 7); // Determine which week it is
        if (weekOfMonth === 2 || weekOfMonth === 4 || weekOfMonth === 5) {
          continue; // Skip these Saturdays
        }
      }

      // Skip dates in the 'twoo' array
      if (isInTwoo(currentDate)) {
        continue;
      }

      daysAdded++; // Only increment if it's a valid day (not skipped)
    }

    return currentDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  function openGoogleMap(ff) {
    if (
      ff?.location === undefined ||
      ff?.location === "" ||
      ff?.location === null
    ) {
      alert("Location Not Available");
    } else {
      let loc = JSON.parse(ff?.location);

      const url = `https://www.google.com/maps?q=${loc?.coords?.latitude},${loc?.coords?.longitude}`;
      window.open(url, "_blank"); // Opens Google Maps in a new tab
    }
  }

 function newaddWorkingDayt3(count, twoo , hhh) {
        let currentDate = new Date(hhh); // Start with today's date
        let daysAdded = 0; // Keep track of how many valid days we've added
    
        // Helper function to check if the current date is in the 'twoo' array
        function isInTwoo(date) {
            let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
            return twoo.includes(dateStr);
        }
    
        while (daysAdded < count) {
            currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
            let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday
    
            // Skip Sundays
            if (dayOfWeek === 0) {
                continue;
            }
    
            // Skip all Saturdays
            if (dayOfWeek === 6) {
                continue;
            }
    
            // Skip dates in the 'twoo' array
            if (isInTwoo(currentDate)) {
                continue;
            }
    
            daysAdded++; // Only increment if it's a valid day (not skipped)
        }
    
        return currentDate.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit", 
            year: "numeric",
        });
      }

  let fraud = async (tt) => {

    try {
      let token = await localStorage.getItem("token");
      let pp = { token, userid: tt.id, verify: tt.user.fraud };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/fraud",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        fraud: true,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    fraud: true,
                  },
                };

                setCharge(updatedData);

                // setFF({ ...ff, freeze: true });
              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        fraud: false,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    fraud: false,
                  },
                };

                setCharge(updatedData);
                // setFF({ ...ff, freeze: false });
              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let marklist = async (tt) => {

    try {
      let token = await localStorage.getItem("token");
      let pp = { token, userid: tt.id, verify: tt.user.marklist };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/marklist",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        marklist: true,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    marklist: true,
                  },
                };

                setCharge(updatedData);

                // setFF({ ...ff, freeze: true });
              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        marklist: false,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    marklist: false,
                  },
                };

                setCharge(updatedData);
                // setFF({ ...ff, freeze: false });
              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let [notes, setNotes] = useState("");
  let [notesshow, setNotesshow] = useState(false);

  let addnotes = async (tt) => {




    if (notes === "" || notes === undefined || notes === null) {

      alert("Please enter notes");
      return;

    }
    try {

      let token = await localStorage.getItem("token");
      let pp = { token, payid: tt.pg_transactionId, msg: notes };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/addnotes",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            setNotes(Jsson?.data?.pay_notes)
            // let [ff, setFF] = useState();
            // setFF(ff.pay_notes = Jsson?.data?.pay_notes) 
            setFF(prev => ({
              ...prev,
              pay_notes: Jsson?.data?.pay_notes
            }));
            alert('notes added')
          } else {

          }
        })
        .catch((ee) => {

        });


    } catch (err) { }
  };


  let reelsubmit = async () => {





    try {

      let pp = { id: ff._id, type: selkdone };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/addtypepg",
        data: pp,
      })
        .then((dat) => {


          if (dat.data.status) {
            ff.real_payment_type = selkdone;
            ff.real_payment_con_fees = JSON.stringify(dat.data.data)





          }
          window.location.reload();
        })
        .catch((ee) => {

        })


    } catch (err) {

    }

  }



  let selectedddhahas = async () => {

    console.log(ff, 'ffffffffffffffffffffffffffffffffffffffffffff')

    let ggggg = `
    
    
     <!DOCTYPE html>
              <html lang="en">
              
              <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Receipt</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                    }
              
                    .invoice {
                        padding: 20px;
                    }
              
                    .invoice2 {
                        height: auto;
                        margin: 0 auto; 
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                        padding-left : 20px;
                        padding-right : 20px;
                        padding-top : 30px;
                    }
              
                    .header {
                        text-align: center;
                        font-size: 24px;
                        margin-bottom: 20px;
                    }
              
                    .details {}
              
                    .item {
                        display: flex;
                        justify-content: space-around;
                        margin-bottom: 10px;
                    }
              
                    .item-top {
                        display: flex;
                        justify-content: space-between;
                    }
              
                    .item span {
                        flex: 1;
                        text-align: center;
                    }
              
                    .total {
                        font-weight: bold;
                        font-size: 18px;
                    }
              
                    .divider {
                      border: none;
                      height: 1px;
                      background-color: #ababab;
                      margin: 20px 0; /* Adjust margin as needed */
                      opocity: 0.1; 
                      margin-top: -0px;
                    }
                </style>
              </head>
              
              <body>
                <div class="invoice2">
              
              
                    <div>
                        <div style=" background-color: #fff; padding : 10px ">
                            <div style="display : flex; justify-content : space-between ">
                                <div> 
                                    <img style='width : 125px' src='data:image/png;base64,${fineimg}' />
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ; margin-top : 20px; ">Wenoxo Technologies Pvt.Ltd.</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">GST Regsitration No: 33AADCW5769J1ZV</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">No.398A, 2nd Floor, MS Rd, Kattayanvilai,</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">Nagercoil, Tamilnadu 629003</p>

                                </div>
                                <div  ">
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">Tax Invoice/bill of Supply/Cash Memo</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px; text-align : center;">(Originial for Recipient)</p>

                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 5px ; margin-top : 20px; ">Billing To : ${ff?.user?.name}</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px; width : 218px ">Address : ${ff?.aadhar?.address}</p> 

            
                                </div>
              
                            </div>
              
                        </div>

                        <hr class="divider">
            
              
              
                      <div style="display : flex; justify-content : space-between " >
                        <div > 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">Date : ${convertDateString(ff?.createdAt)}</p>
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;  ">Order No : ${ff?.xopay_id}</p>
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; ">Invoice Number : ${ff?.pg_transactionId}</p>
                        </div>
                        <div style="margin-top : 20px" > 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; 
                          ">Status : <span style="color : ${ff?.payment_status_msg === "Processing" ? "#F99417" : ff?.payment_status_msg === "Success" ? "#0C9C18" : "#FF0000"} ">
                          
                          ${ff?.payment_status_msg}</span></p> 
                        </div>
                      </div >

                      <table style="width :100% ; margin-top : 20px">
                        <thead style=" background-color : #A6A6A630;  ">
                          <tr>
                            <th style="padding : 15px; text-align : center ; font-size : 11px">Item</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >Amount(₹)</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >Convenience
            Fees</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >HSN/SAC</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >Tax Rate & Type</th>
                            <th style="padding : 15px; text-align : center ; font-size : 11px"" >Tax Amount</th>
                            <th style="padding : 15px; text-align : center ; font-size : 11px"" >Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">${allsselasdata}</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.amount}</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.co_fess
                  }</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px; text-align : center ">00000</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">18%</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.gst}</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.totalamount}</p></td> 
                          </tr> 
                          <tr>
                            <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">Grand Total</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px; text-align : center ">₹ ${ff?.totalamount}</p></td> 
                          </tr> 

                      
                        </tbody> 
              
                      </table>
              <hr class="divider">
              
                      
                      <div style="padding : 10px" >
                        <div style="display : flex; justify-content : space-between "  >
                        <div >

                        <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">
                          
                          We declare that this invoice shows the</p> 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">actual price of 
                          the services described that all particulars are true and </p> 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">correct.</p> 


                        </div >

                        <div >

                        <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; text-align : right  ">*This is a computer generated invoice and does not requiree</p> 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px; text-align : right   ">a physical signature </p>  
                        </div >
                        </div>
                          
                        </div>


                        
                    </div>


              
                </div>
                </div>
              
              </body>
              
              </html>
              
              
              `


    sethtmlString(ggggg)


    setTimeout(() => {
      hhhfhf()
    }, 1000);






  }


  let hhhfhf = async () => {
    const element = contentRef.current;

    const canvas = await html2canvas(element, {
      scale: 6, // 🟢 Higher scale = sharper image
      useCORS: true,
    });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('receipt.pdf');
  }



   let vvback = async () => {

    console.log(ff , 'LLLLLLLLLLLLLLLLLLLLLLLL')
      setfouers(0);
                  setthrees(0);
                  settwos(0);
                  setones(0);
                  setPikk(false);

                  setFF();
                  setCharge();
                  setDatae();
                  setChsrggess();

                  Setpg_res();

                  setSms([]);
  };


  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        >
          {pikk === true ? (
            // <>
            //   <p
            //     onClick={() => {
            //       setfouers(0);
            //       setthrees(0);
            //       settwos(0);
            //       setones(0);
            //       setPikk(false);

            //       setFF();
            //       setCharge();
            //       setDatae();
            //       setChsrggess();

            //       Setpg_res();

            //       setSms([]);
            //     }}
            //     style={{ fontWeight: "700" }}
            //   >
            //     {"<"} Go back
            //   </p>
            //   <div>
            //     <div className="row">
            //       <div
            //         className="col-6"
            //         style={{
            //           border: "1px solid #ddd",
            //           padding: "10px",
            //           backgroundColor:
            //             charge?.user?.fraud === true
            //               ? "orange"
            //               : charge?.user?.marklist === true
            //                 ? "#fc97f1"
            //                 : "#fff",
            //         }}
            //       >
            //         <p onClick={() => {

            //         }} style={{ fontSize: 20, fontWeight: "bold" }}>
            //           User Detail
            //         </p>
            //         <table style={{ width: "100%" }}>
            //           <tbody>
            //             <tr>
            //               <td>{charge?.user?.name}</td>
            //             </tr>
            //             <tr>
            //               <td>{charge?.user?.phoneno}</td>
            //             </tr>
            //             <tr>
            //               <td>{charge?.user?.email}</td>

            //               <div className="d-flex gap-3">
            //                 <button
            //                   onClick={() => {
            //                     verifyy(ff);
            //                   }}
            //                 >
            //                   Verify
            //                 </button>
            //                 <button
            //                   onClick={() => {
            //                     Freeze(ff);
            //                   }}
            //                 >
            //                   Freeze
            //                 </button>

            //                 <button
            //                   onClick={() => {
            //                     openGoogleMap(ff);
            //                   }}
            //                 >
            //                   Location
            //                 </button>

            //                 <button
            //                   onClick={() => {
            //                     fraud(ff);
            //                   }}
            //                 >
            //                   Fraud
            //                 </button>

            //                 <button
            //                   onClick={() => {
            //                     marklist(ff);
            //                   }}
            //                 >
            //                   Marklist
            //                 </button>

            //                 <button
            //                   onClick={() => {

            //                     if (notesshow === true) {
            //                       setNotesshow(false);
            //                     } else {
            //                       setNotesshow(true);
            //                     }


            //                   }}
            //                 >
            //                   Add Notes
            //                 </button>
            //               </div>
            //               <div className="d-flex gap-3 mt-3" >


            //                 <select
            //                   onChange={(e) => {
            //                     // setSelas(e.target.value); 
            //                     console.log(e.target.value, 'ggggggggggggggggggggggggggggggggggggggg')
            //                     setallSelasdata(e.target.value)


            //                   }}
            //                   name="payment_status"
            //                   id="payment_status"
            //                   style={{
            //                     padding: "5px",
            //                     borderRadius: "4px",
            //                     border: "1px solid #ccc",
            //                   }}
            //                 >
            //                   {
            //                     allsselas.map((data, index) => {
            //                       return (
            //                         <option
            //                           value={data}
            //                         >
            //                           {data}
            //                         </option>
            //                       )
            //                     })
            //                   }
            //                 </select>


            //                 <button
            //                   onClick={() => {
            //                     selectedddhahas()
            //                   }}
            //                 >
            //                   Download Pdf
            //                 </button>


            //               </div>
            //             </tr>
            //           </tbody>
            //         </table>
            //       </div>

            //       <div
            //         className="col-6"
            //         style={{ border: "1px solid #ddd", padding: "10px" }}
            //       >
            //         <div style={{ borderRadius: "5px" }}>
            //           <table style={{ width: "100%" }}>
            //             <tbody>
            //               <tr>
            //                 <p
            //                   style={{
            //                     color:
            //                       ff?.payment_status_msg === "Processing" ||
            //                         ff?.payment_status_msg === "Progress"
            //                         ? "orange"
            //                         : ff?.payment_status_msg === "Failed"
            //                           ? "red"
            //                           : "green",
            //                     fontWeight: "700",
            //                   }}
            //                 >
            //                   {ff?.payment_status_msg}
            //                 </p>
            //                 <p>
            //                   Payment date : {convertDateString(ff?.createdAt)}
            //                 </p>
            //                 <div className="d-flex gap-3">
            //                   {ff?.verified === true ? (
            //                     <p style={{ color: "blue", fontWeight: "700" }}>
            //                       Verified
            //                     </p>
            //                   ) : (
            //                     ""
            //                   )}

            //                   {ff?.freeze === true ? (
            //                     <p style={{ color: "blue", fontWeight: "700" }}>
            //                       Freezed
            //                     </p>
            //                   ) : (
            //                     ""
            //                   )}
            //                 </div>

            //                 {ff?.payment_status_msg === "Processing" ||
            //                   ff?.payment_status_msg === "Progress" ? (
            //                   <p style={{ color: "blue", fontWeight: "700" }}>
            //                     Settlement :{" "}
            //                     {charggges?.title === "T1"
            //                       ? newaddWorkingDayt3(1, leave , ff?.createdAt  )
            //                       : charggges?.title === "Sameday"
            //                         ? "4 to 5 hours"
            //                         : charggges?.title === "T2"
            //                           ? newaddWorkingDayt3(2, leave, ff?.createdAt)
            //                           : newaddWorkingDayt3(3, leave, ff?.createdAt)}
            //                   </p>
            //                 ) : (
            //                   ""
            //                 )}
            //               </tr>
            //               <tr>
            //                 <td
            //                   style={{
            //                     paddingRight: "10px",
            //                     fontWeight: "bold",
            //                   }}
            //                 >
            //                   <select
            //                     onChange={(e) => {
            //                       setSelas(e.target.value);

            //                       if (e.target.value === 'Refund') {
            //                         setShowrefund(true)
            //                       } else {
            //                         setShowrefund(false)
            //                       }



            //                       console.log(e.target.value, 'ggggggggggggggggggggggggggggggggggggggg')



            //                     }}
            //                     name="payment_status"
            //                     id="payment_status"
            //                     style={{
            //                       padding: "5px",
            //                       borderRadius: "4px",
            //                       border: "1px solid #ccc",
            //                     }}
            //                   >
            //                     <option
            //                       value="Failed"
            //                       selected={ff?.payment_status_msg === "Failed"}
            //                     >
            //                       Failed
            //                     </option>
            //                     <option
            //                       value="Success"
            //                       selected={
            //                         ff?.payment_status_msg === "Success"
            //                       }
            //                     >
            //                       Success
            //                     </option>
            //                     <option
            //                       value="Processing"
            //                       selected={
            //                         ff?.payment_status_msg === "Processing"
            //                       }
            //                     >
            //                       Processing 
            //                     </option>
            //                     <option
            //                       value="Refund"
            //                       selected={ff?.payment_status_msg === "Refund"}
            //                     >
            //                       Refund
            //                     </option>
            //                     <option
            //                       value="Chargeback"
            //                       selected={ff?.chargeback === true}
            //                     >
            //                       Charge Back
            //                     </option>

            //                   </select>
            //                 </td>

            //                 <td colSpan="2" style={{ paddingTop: "20px" }}>
            //                   <button
            //                     onClick={() => {
            //                       update();
            //                     }}
            //                     style={{
            //                       padding: "10px 20px",
            //                       border: "none",
            //                       borderRadius: "4px",
            //                       backgroundColor: "#007bff",
            //                       color: "white",
            //                       cursor: "pointer",
            //                     }}
            //                   >
            //                     Submit
            //                   </button>
            //                 </td>
            //               </tr>
            //               <tr>
            //                 <td>
            //                   <tr>
            //                     {/* <div className="row" >
            //                       <div className="col-6" >
            //                         <p>User Remark</p>
            //                         <textarea
            //                           onChange={(e) => {

            //                           }}
            //                           type="text"
            //                           style={{ width: "100%" }}
            //                           placeholder="Enter Remark"
            //                         />
            //                       </div>
            //                       <div className="col-6" >
            //                         <p>Admion Remark</p>
            //                         <textarea
            //                           onChange={(e) => {

            //                           }}
            //                           type="text"
            //                           style={{ width: "100%" }}
            //                           placeholder="Enter Remark"
            //                         />
            //                       </div>
            //                     </div> */}
            //                   </tr>
            //                 </td>
            //               </tr>
            //             </tbody>
            //           </table>
            //         </div>
            //       </div>
            //     </div>

            //     <div className="row">
            //       <div
            //         className="col-6"
            //         style={{ border: "1px solid #ddd", padding: "10px" }}
            //       >
            //         <p
            //           style={{
            //             fontSize: 20,
            //             fontWeight: "bold",
            //             marginBottom: "10px",
            //           }}
            //         >
            //           Aadhar Detail
            //         </p>
            //         <table style={{ width: "100%" }}>
            //           <tbody>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Aadhar Name:
            //               </td>
            //               <td>{charge?.aadhar?.name}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Gender:
            //               </td>
            //               <td>{charge?.aadhar?.gender}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Date of Birth:
            //               </td>
            //               <td>{charge?.aadhar?.year_of_birth}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Address:
            //               </td>
            //               <td>{charge?.aadhar?.address}</td>
            //             </tr>
            //           </tbody>
            //         </table>
            //       </div>

            //       <div
            //         className="col-6"
            //         style={{ border: "1px solid #ddd", padding: "10px" }}
            //       >
            //         <p
            //           style={{
            //             fontSize: 20,
            //             fontWeight: "bold",
            //             marginBottom: "10px",
            //           }}
            //         >
            //           Pan Detail
            //         </p>
            //         <table style={{ width: "100%" }}>
            //           <tbody>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Pan Name:
            //               </td>
            //               <td>{charge?.pan?.name_pan_card}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Pan Registered Name:
            //               </td>
            //               <td>{charge?.pan?.registered_name}</td>
            //             </tr>
            //           </tbody>
            //         </table>
            //       </div>
            //     </div>

            //     <p style={{ fontWeight: '700', color: 'red' }} className="mt-3">
            //       {ff?.pay_notes}
            //     </p>

            //     {notesshow === true ? (
            //       <div className="d-flex mt-3">
            //         <textarea
            //           onChange={(e) => { setNotes(e.target.value) }}
            //           style={{ border: "1px solid #ddd", width: "50%" }}
            //         ></textarea>
            //         <div
            //           style={{
            //             alignItems: "center",
            //             marginLeft: 10,
            //             marginTop: 20,
            //           }}
            //         >
            //           <button
            //             style={{
            //               padding: "10px 20px",
            //               border: "none",
            //               borderRadius: "4px",
            //               backgroundColor: "#007bff",
            //               color: "white",
            //               cursor: "pointer",
            //             }}

            //             onClick={() => {
            //               addnotes(ff)
            //             }}
            //           >
            //             Submit
            //           </button>
            //         </div>
            //       </div>
            //     ) : (
            //       ""
            //     )}

            //     <div className="row mt-5">
            //       <div
            //         className="col-12"
            //         style={{ border: "1px solid #ddd", padding: "10px" }}
            //       >
            //         <table style={{ width: "100%" }}>
            //           <tbody>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Xopay ID :
            //               </td>
            //               <td>{ff?.xopay_id}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 PG Transaction ID :
            //               </td>
            //               <td>{ff?.pg_transactionId}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Notes : {ff?.pay_notes}
            //               </td>
            //             </tr>

            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px", color: 'red' }}  >
            //                 User Select Payment type : {JSON.parse(ff?.typevalue)?.item?.name}
            //               </td>
            //             </tr>

            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px", color: 'red' }}  >
            //                 charge : {JSON.parse(ff?.typevalue)?.item?.charge}
            //               </td>
            //             </tr>

            //           </tbody>
            //         </table>
            //       </div>
            //     </div>

            //     <div className="row">
            //       <div className="col-3" style={{ border: "1px solid #ddd" }}>
            //         <p style={{ fontSize: 20, fontWeight: "bold" }}>
            //           Beneficiary Detail
            //         </p>
            //         <table style={{ width: "100%" }}>
            //           <tbody>
            //             <tr>
            //               <td style={{ fontWeight: "bold" }}>Name:</td>
            //               <td>{datae?.name}</td>
            //             </tr>
            //             <tr>
            //               <td style={{ fontWeight: "bold" }}>Phone:</td>
            //               <td>{datae?.phone}</td>
            //             </tr>
            //             <tr>
            //               <td style={{ fontWeight: "bold" }}>Email:</td>
            //               <td>{datae?.email}</td>
            //             </tr>
            //             <tr>
            //               <td style={{ fontWeight: "bold" }}>Account No:</td>
            //               <td>{datae?.bankaccountno}</td>
            //             </tr>
            //             <tr>
            //               <td style={{ fontWeight: "bold" }}>IFSC code:</td>
            //               <td>{datae?.ifsc}</td>
            //             </tr>
            //           </tbody>
            //         </table>
            //       </div>
            //       <div
            //         className="col-3"
            //         style={{ border: "1px solid #ddd", padding: "10px" }}
            //       >
            //         <p style={{ fontSize: 20, fontWeight: "bold" }}>
            //           Payment Detail
            //         </p>

            //         <table style={{ width: "100%" }}>
            //           <tbody>
            //             <tr>
            //               <td
            //                 style={{
            //                   fontWeight: "bold",
            //                   paddingRight: "10px",
            //                   color: "red",
            //                 }}
            //               >
            //                 Charge:
            //               </td>
            //               <td style={{ color: "red" }}>{charggges?.title}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Fees:
            //               </td>
            //               <td>{charggges?.fee}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Amount:
            //               </td>
            //               <td>₹ {ff?.amount}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Convenience Fees:
            //               </td>
            //               <td>₹ {ff?.co_fess}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 GST:
            //               </td>
            //               <td>₹ {ff?.gst}</td>
            //             </tr>
            //             <tr>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 reward:
            //               </td>
            //               <td>₹ - {ff?.reward || 0}</td>
            //             </tr>

            //             <tr style={{ marginBottom: 20 }}>
            //               <td
            //                 style={{ fontWeight: "bold", paddingRight: "10px" }}
            //               >
            //                 Total:
            //               </td>
            //               <td>₹ {ff?.totalamount}</td>
            //             </tr>

            //             {pg_res?.data?.payment?.payment_group ===
            //               "prepaid_card" ||
            //               pg_res?.cardCategory === "prepaid" ? (
            //               <>
            //                 <tr style={{ paddingTop: 20 }}>
            //                   <td
            //                     style={{
            //                       fontWeight: "bold",
            //                       paddingRight: "10px",
            //                       color: "red",
            //                     }}
            //                   >
            //                     prepaid_card charge :
            //                   </td>
            //                   <td
            //                     style={{
            //                       fontWeight: "bold",
            //                       paddingRight: "10px",
            //                       color: "red",
            //                     }}
            //                   >
            //                     ₹ {prepaidfees}
            //                   </td>
            //                 </tr>

            //                 <tr style={{ paddingTop: 20 }}>
            //                   <td
            //                     style={{
            //                       fontWeight: "bold",
            //                       paddingRight: "10px",
            //                       color: "red",
            //                     }}
            //                   >
            //                     prepaid_card GST :
            //                   </td>
            //                   <td
            //                     style={{
            //                       fontWeight: "bold",
            //                       paddingRight: "10px",
            //                       color: "red",
            //                     }}
            //                   >
            //                     ₹ {text}
            //                   </td>
            //                 </tr>

            //                 <tr>
            //                   <td
            //                     style={{
            //                       fontWeight: "bold",
            //                       paddingRight: "10px",
            //                       color: "red",
            //                     }}
            //                   >
            //                     Final Settlement Amount :
            //                   </td>
            //                   <td
            //                     style={{
            //                       fontWeight: "bold",
            //                       paddingRight: "10px",
            //                       color: "red",
            //                     }}
            //                   >
            //                     ₹ {Number(ff.amount) - prepaidfees - text}
            //                   </td>
            //                 </tr>
            //               </>
            //             ) : (
            //               ""
            //             )}
            //           </tbody>
            //         </table>



            //         {

            //           ff?.real_payment_type === "" || ff?.real_payment_type === undefined || ff?.real_payment_type === null ?
            //             ""
            //             :

            //             <>
            //               <p style={{ fontSize: 20, fontWeight: "bold" }} className="mt-5">
            //                 After change Payment Detail
            //               </p>

            //               <table style={{ width: "100%" }} >
            //                 <tbody>
            //                   <tr>
            //                     <td
            //                       style={{
            //                         fontWeight: "bold",
            //                         paddingRight: "10px",
            //                         color: "red",
            //                       }}
            //                     >
            //                       Charge:
            //                     </td>
            //                     <td style={{ color: "red" }}>{charggges?.title}</td>
            //                   </tr>
            //                   <tr>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px" }}
            //                     >
            //                       Fees:
            //                     </td>
            //                     <td>{charggges?.fee}</td>
            //                   </tr>
            //                   <tr>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px" }}
            //                     >
            //                       Amount:
            //                     </td>
            //                     <td>₹ {ff?.amount}</td>
            //                   </tr>


            //                   <tr>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px", color: 'red' }}
            //                     >
            //                       New Convenience Fees present :
            //                     </td>
            //                     <td style={{ color: 'red' }}>
            //                       {(() => {
            //                         try {
            //                           const parsed = JSON.parse(ff?.real_payment_con_fees || '[]');
            //                           return `${parsed?.[0]?.charge ?? '-'} %`;
            //                         } catch {
            //                           return '- %';
            //                         }
            //                       })()}
            //                     </td>
            //                   </tr>

            //                   <tr>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px" }}
            //                     >
            //                       Convenience Fees:
            //                     </td>
            //                     <td>
            //                       ₹ {
            //                         (() => {
            //                           try {
            //                             const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
            //                             const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
            //                             const amount = Number(ff?.amount || 0);

            //                             const total = ((chargeFee + realPaymentFee) / 100) * amount;
            //                             return total.toFixed(2);
            //                           } catch {
            //                             return '0.00';
            //                           }
            //                         })()
            //                       }
            //                     </td>
            //                   </tr>


            //                   <tr>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px" }}
            //                     >
            //                       GST:
            //                     </td>
            //                     <td>
            //                       ₹ {
            //                         (() => {
            //                           try {
            //                             const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
            //                             const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
            //                             const amount = Number(ff?.amount || 0);

            //                             const baseCharge = ((chargeFee + realPaymentFee) / 100) * amount;
            //                             const gst = (baseCharge * 18) / 100;

            //                             return gst.toFixed(2);
            //                           } catch {
            //                             return '0.00';
            //                           }
            //                         })()
            //                       }
            //                     </td>
            //                   </tr>


            //                   <tr>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px" }}
            //                     >
            //                       reward:
            //                     </td>
            //                     <td>₹ - {ff?.reward || 0}</td>
            //                   </tr>

            //                   <tr style={{ marginBottom: 20 }}>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px" }}
            //                     >
            //                       Total:
            //                     </td>
            //                     <td>
            //                       ₹ {
            //                         (() => {
            //                           try {
            //                             const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
            //                             const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
            //                             const amount = Number(ff?.amount || 0);

            //                             const baseCharge = ((chargeFee + realPaymentFee) / 100) * amount;
            //                             const gst = (baseCharge * 18) / 100;
            //                             const total = amount + baseCharge + gst;

            //                             return total.toFixed(2);
            //                           } catch {
            //                             return '0.00';
            //                           }
            //                         })()
            //                       }
            //                     </td>
            //                   </tr>


            //                   <tr style={{ marginBottom: 20 }}>
            //                     <td
            //                       style={{ fontWeight: "bold", paddingRight: "10px" }}
            //                     >
            //                       Settlement Amount :
            //                     </td>
            //                     <td>
            //                       ₹ {
            //                         (() => {
            //                           try {
            //                             const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
            //                             const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
            //                             const amount = Number(ff?.amount || 0);

            //                             const baseCharge = ((chargeFee + realPaymentFee) / 100) * amount;
            //                             const gst = (baseCharge * 18) / 100;
            //                             const total = amount + baseCharge + gst;
            //                             let totalamount = Number(ff?.totalamount || 0)
            //                             let givenamount = total - totalamount

            //                             let finalconamount = 0

            //                             if (givenamount < 0) {
            //                               finalconamount = amount + Math.abs(givenamount)
            //                             } else {
            //                               finalconamount = amount - Math.abs(givenamount)
            //                             }


            //                             return finalconamount.toFixed(2);
            //                           } catch {
            //                             return '0.00';
            //                           }
            //                         })()
            //                       }
            //                     </td>
            //                   </tr>


            //                   {pg_res?.data?.payment?.payment_group ===
            //                     "prepaid_card" ||
            //                     pg_res?.cardCategory === "prepaid" ? (
            //                     <>
            //                       <tr style={{ paddingTop: 20 }}>
            //                         <td
            //                           style={{
            //                             fontWeight: "bold",
            //                             paddingRight: "10px",
            //                             color: "red",
            //                           }}
            //                         >
            //                           prepaid_card charge :
            //                         </td>
            //                         <td
            //                           style={{
            //                             fontWeight: "bold",
            //                             paddingRight: "10px",
            //                             color: "red",
            //                           }}
            //                         >
            //                           ₹ {prepaidfees}
            //                         </td>
            //                       </tr>

            //                       <tr style={{ paddingTop: 20 }}>
            //                         <td
            //                           style={{
            //                             fontWeight: "bold",
            //                             paddingRight: "10px",
            //                             color: "red",
            //                           }}
            //                         >
            //                           prepaid_card GST :
            //                         </td>
            //                         <td
            //                           style={{
            //                             fontWeight: "bold",
            //                             paddingRight: "10px",
            //                             color: "red",
            //                           }}
            //                         >
            //                           ₹ {text}
            //                         </td>
            //                       </tr>

            //                       <tr>
            //                         <td
            //                           style={{
            //                             fontWeight: "bold",
            //                             paddingRight: "10px",
            //                             color: "red",
            //                           }}
            //                         >
            //                           Final Settlement Amount :
            //                         </td>
            //                         <td
            //                           style={{
            //                             fontWeight: "bold",
            //                             paddingRight: "10px",
            //                             color: "red",
            //                           }}
            //                         >
            //                           ₹ {Number(ff.amount) - prepaidfees - text}
            //                         </td>
            //                       </tr>
            //                     </>
            //                   ) : (
            //                     ""
            //                   )}
            //                 </tbody>
            //               </table>
            //             </>

            //         }



            //       </div>
            //       <div className="col-6" style={{ border: "1px solid #ddd" }}>
            //         {sms?.length !== 0 ? (
            //           <table className="table table-bordered">
            //             <thead className="thead-dark">
            //               <tr>
            //                 <th scope="col">Send By</th>
            //                 <th scope="col">Time</th>
            //                 <th scope="col">Message</th>
            //               </tr>
            //             </thead>
            //             <tbody>
            //               {sms?.map((tt, index) => (
            //                 <tr key={index} style={{ cursor: "pointer" }}>
            //                   <td>{tt?.address}</td>
            //                   <td>{fffff(tt?.date_sent)}</td>
            //                   <td>{tt?.body}</td>
            //                 </tr>
            //               ))}
            //             </tbody>
            //           </table>
            //         ) : (
            //           <p>No SMS data available</p>
            //         )}
            //       </div>
            //     </div>
            //   </div>



            //   <div className="row mt-4" >

            //     <div className="col-6" >
            //       <p
            //         style={{
            //           fontSize: 20,
            //           fontWeight: "bold",
            //           marginBottom: "10px",
            //           cursor: "pointer",
            //         }}
            //         onClick={() => {

            //         }}
            //       >
            //         Pg Responce <span style={{ color: "blue" }}>{ff?.pg}</span>
            //       </p>
            //     </div>
            //     <div className="col-3" >
            //       <select
            //         onChange={(e) => {
            //           setSelkdone(e.target.value);
            //         }}
            //       >
            //         <option
            //           value="visa"
            //           selected={selkdone === "visa" ? true : false}
            //         >
            //           visa
            //         </option>
            //         <option
            //           value="master"
            //           selected={selkdone === "master" ? true : false}
            //         >
            //           master
            //         </option>
            //         <option
            //           value="RuPay"
            //           selected={selkdone === "RuPay" ? true : false}
            //         >
            //           RuPay
            //         </option>

            //         <option
            //           value="AMEX"
            //           selected={selkdone === "AMEX" ? true : false}
            //         >
            //           AMEX
            //         </option>

            //         <option
            //           value="Dynex"
            //           selected={selkdone === "Dynex" ? true : false}
            //         >
            //           Dynex
            //         </option>

            //         <option
            //           value="Wallet"
            //           selected={selkdone === "Wallet" ? true : false}
            //         >
            //           Wallet
            //         </option>

            //       </select>
            //     </div>
            //     <div className="col-3" >
            //       <button
            //         onClick={() => {
            //           reelsubmit()
            //         }}
            //       >
            //         Submit
            //       </button>
            //     </div>

            //   </div>

            //   <table style={{ width: "100%", marginBottom: 50 }}>
            //     <tbody className="row">
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.customer_details?.customer_name ||
            //             pg_res?.firstname}
            //         </td>
            //       </tr>
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.customer_details?.customer_email ||
            //             pg_res?.email}
            //         </td>
            //       </tr>
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.customer_details?.customer_phone ||
            //             pg_res?.phone}
            //         </td>
            //       </tr>
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.payment?.payment_group || pg_res?.mode}
            //         </td>
            //       </tr>
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.payment?.payment_method?.card
            //             ?.card_number || pg_res?.cardnum}
            //         </td>
            //       </tr>
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.payment?.payment_method?.card
            //             ?.card_network || pg_res?.cardCategory}
            //         </td>
            //       </tr>
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.payment?.cf_payment_id ||
            //             pg_res?.bank_ref_num}
            //         </td>
            //       </tr>
            //       <tr className="col">
            //         <td>
            //           {pg_res?.data?.payment?.payment_amount ||
            //             pg_res?.net_amount_debit}
            //         </td>
            //       </tr>
            //     </tbody>
            //   </table>

            //   {charge?.pay?.length === 0 || charge?.pay === undefined ? (
            //     ""
            //   ) : (
            //     <>
            //       <div className="d-flex">
            //         <div className=" ">
            //           <p
            //             style={{
            //               fontSize: 20,
            //               fontWeight: "bold",
            //               marginBottom: "10px",
            //               cursor: "pointer",
            //             }}
            //           >
            //             Previous Payment
            //           </p>
            //         </div>
            //         <div className="" style={{ marginLeft: 20 }}>
            //           <select
            //             onChange={(e) => {
            //               setSelkd(e.target.value);
            //             }}
            //             name="cars"
            //             id="cars"
            //           >
            //             <option
            //               value="All"
            //               selected={selkd === "All" ? true : false}
            //             >
            //               All
            //             </option>
            //             <option
            //               value="Failed"
            //               selected={selkd === "Failed" ? true : false}
            //             >
            //               Failed
            //             </option>
            //             <option
            //               value="Success"
            //               selected={selkd === "Success" ? true : false}
            //             >
            //               Success
            //             </option>
            //             <option
            //               value="Processing"
            //               selected={selkd === "Processing" ? true : false}
            //             >
            //               Processing
            //             </option>

            //             <option
            //               value="Refund"
            //               selected={selkd === "Refund" ? true : false}
            //             >
            //               Refund
            //             </option>

            //             <option
            //               value="verified"
            //               selected={selkd === "verified" ? true : false}
            //             >
            //               Verified
            //             </option>
            //           </select>
            //         </div>
            //       </div>

            //       <table
            //         className="table table-bordered"
            //         style={{ width: "90%", marginBottom: 50 }}
            //       >
            //         <tbody>
            //           {charge?.pay?.slice().reverse().map((dfr, key) => {
            //             if (selkd === "All") {
            //             } else if (selkd === "Processing") {
            //               if (dfr?.payment_status_msg != "Processing") {
            //                 return;
            //               }
            //             } else if (selkd === "Failed") {
            //               if (dfr?.payment_status_msg != "Failed") {
            //                 return;
            //               }
            //             } else if (selkd === "Success") {
            //               if (dfr?.payment_status_msg != "Success") {
            //                 return;
            //               }
            //             } else if (selkd === "Refund") {
            //               if (dfr?.payment_status_msg != "Refund") {
            //                 return;
            //               }
            //             } else if (selkd === "verified") {
            //               if (dfr?.verified != true) {
            //                 return;
            //               }
            //             }

            //             let parsedata = "";
            //             if (
            //               dfr?.pg_res === "" ||
            //               dfr?.pg_res === undefined ||
            //               dfr?.pg_res === null
            //             ) {
            //               parsedata = {
            //                 data: {
            //                   order: {
            //                     order_id: "",
            //                     order_amount: "",
            //                     order_currency: "",
            //                     order_tags: null,
            //                   },
            //                   payment: {
            //                     cf_payment_id: "",
            //                     payment_status: "",
            //                     payment_amount: "",
            //                     payment_currency: "",
            //                     payment_message: "",
            //                     payment_time: "",
            //                     bank_reference: "",
            //                     auth_id: null,
            //                     payment_method: {
            //                       card: {
            //                         channel: null,
            //                         card_number: "",
            //                         card_network: "",
            //                         card_type: "",
            //                         card_sub_type: "",
            //                         card_country: "",
            //                         card_bank_name: "",
            //                       },
            //                     },
            //                     payment_group: "",
            //                   },
            //                   customer_details: {
            //                     customer_name: "",
            //                     customer_id: "",
            //                     customer_email: "",
            //                     customer_phone: "",
            //                   },
            //                   error_details: {
            //                     error_code: "",
            //                     error_description: "",
            //                     error_reason: "",
            //                     error_source: "",
            //                     error_code_raw: null,
            //                     error_description_raw: null,
            //                   },
            //                   payment_gateway_details: {
            //                     gateway_name: "",
            //                     gateway_order_id: null,
            //                     gateway_payment_id: "",
            //                     gateway_status_code: null,
            //                     gateway_order_reference_id: "",
            //                     gateway_settlement: null,
            //                   },
            //                   payment_offers: null,
            //                 },
            //                 event_time: "",
            //                 type: "",
            //               };
            //             } else {
            //               parsedata = JSON.parse(dfr?.pg_res);
            //             }



            //             console.log(dfr , 'parsedataparsedataparsedataparsedataparsedataparsedataparsedataparsedataparsedata')

            //             let gg = {};

            //             if (dfr?.charge) {
            //               gg = JSON.parse(dfr?.charge);
            //             }

            //             return (
            //               <tr key={key} style={{ cursor: "pointer" }}>
            //                 <td>
            //                   <p style={{ fontWeight: "700" }}>
            //                     card User Detail
            //                   </p>

            //                   <p>
            //                   {charge?.user?.name}
            //                   </p>
            //                   <p>
            //                   {charge?.user?.phoneno}
            //                   </p>
            //                   <p>
            //                   {charge?.user?.email}
            //                   </p> 
            //                 </td>
            //                 <td>
            //                   <p style={{ fontWeight: "700" }}>Ids</p>

            //                   <p>{dfr?.xopay_id}</p>
            //                   <p>
            //                     {dfr?.pg_transactionId}
            //                   </p>
            //                 </td>

            //                 <td>
            //                   <p>
            //                     { convertDateString(dfr?.createdAt)}
            //                   </p>
            //                   <p>
            //                     {dfr?.pg}
            //                   </p>
            //                 </td>

            //                 <td>
            //                   <p style={{ color: "red" }}>
            //                     Type : {gg?.title}{" "}
            //                   </p>
            //                   <p>Con fees present : {gg?.fee} %</p>
            //                   <p>Con fees : {dfr?.co_fess}</p>
            //                   <p>gst : {dfr?.gst} %</p>
            //                   <p>
            //                     Total :{" "}
            //                     {dfr?.totalamount}
            //                   </p>
            //                 </td>
            //                 <td>
            //                   <p
            //                     style={{
            //                       color:
            //                         dfr?.payment_status_msg === "Processing" ||
            //                           dfr?.payment_status_msg === "Progress"
            //                           ? "orange"
            //                           : dfr?.payment_status_msg === "Failed"
            //                             ? "red"
            //                             : "green",
            //                       fontWeight: "700",
            //                     }}
            //                   >
            //                     {dfr?.payment_status_msg}
            //                   </p>

            //                   <div className="d-flex gap-3">
            //                     {dfr?.verified === true ? (
            //                       <p
            //                         style={{ color: "blue", fontWeight: "700" }}
            //                       >
            //                         Verified
            //                       </p>
            //                     ) : (
            //                       ""
            //                     )}
            //                     {dfr?.freeze === true ? (
            //                       <p
            //                         style={{ color: "blue", fontWeight: "700" }}
            //                       >
            //                         Freezed
            //                       </p>
            //                     ) : (
            //                       ""
            //                     )}
            //                   </div>
            //                 </td>
            //               </tr>
            //             );
            //           })}
            //         </tbody>
            //       </table>
            //     </>
            //   )}


            //   <div
            //     ref={contentRef}
            //     style={{ width: '215mm', backgroundColor: 'white', zIndex: 10000 }}
            //     dangerouslySetInnerHTML={{ __html: htmlString }}
            //   />


            // </>

            <Producr gobackk={vvback } charge={charge} fffg={ff} smss={sms} allsselasb={[]} datadfg={data} dataedd={datae} chargggesone={charggges} /> 
          ) : (
            <div className="row">
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                  padding: 10,
                }}
              >
                <div className="row">
                  <div className="col-2">
                    <input
                      onChange={(e) => {
                        inputvalue(e.target.value);
                      }}
                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Enter Order Id"
                    />
                  </div>
                  <div className="col-1">
                    <button
                      onClick={() => {
                        searchss();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                  <div className="col-7">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="next >"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      pageCount={count / 10}
                      previousLabel="< previous"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination justify-content-center"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      activeClassName="active"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      forcePage={indexs}
                    />
                  </div>
                  <div className="col-2">
                    <button
                      onClick={() => {
                        navigate("/rentedit");
                      }}
                    >
                      {" "}
                      Edit Rent Fees
                    </button>

                    {/* <button
                      onClick={() => { 
                        navigate('/renteditgateway')
                      }}
                      className="ml-2"
                      style={{ marginLeft : 20 }}
                    >
                      {" "}
                      Edit Gateway
                    </button> */}
                  </div>
                </div>
              </div>
              <table class="table">
                <thead
                  class="thead-dark"
                  style={{
                    position: "sticky",
                    top: 50,
                    backgroundColor: "#fff",
                  }}
                >
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col ">
                      User {"  "}
                      <select
                        onChange={(e) => {
                          setSel(e.target.value);
                          setDatadd(false);
                        }}
                        name="cars"
                        id="cars"
                      >
                        <option
                          value="All"
                          selected={sel === "All" ? true : false}
                        >
                          All
                        </option>
                        <option
                          value="Failed"
                          selected={sel === "Failed" ? true : false}
                        >
                          Failed
                        </option>
                        <option
                          value="Success"
                          selected={sel === "Success" ? true : false}
                        >
                          Success
                        </option>
                        <option
                          value="Processing"
                          selected={sel === "Processing" ? true : false}
                        >
                          Processing
                        </option>

                        <option
                          value="Refund"
                          selected={sel === "Refund" ? true : false}
                        >
                          Refund
                        </option>

                        <option
                          value="verified"
                          selected={sel === "verified" ? true : false}
                        >
                          Verified
                        </option>
                      </select>
                      <select
                        onChange={(e) => {
                          // setSel(e.target.value);
                          setSelsame(e.target.value);
                          setDatadd(true);
                        }}
                        name="cars"
                        id="cars"
                        style={{ marginLeft: 10 }}
                      >
                        <option
                          value="All"
                          selected={selsame === "All" ? true : false}
                        >
                          All
                        </option>
                        <option
                          value="Sameday"
                          selected={selsame === "Sameday" ? true : false}
                        >
                          Sameday
                        </option>
                        <option
                          value="T1"
                          selected={selsame === "T1" ? true : false}
                        >
                          T1
                        </option>
                        <option
                          value="T2"
                          selected={selsame === "T2" ? true : false}
                        >
                          T2
                        </option>
                      </select>
                    </th>
                    <th scope="col">Ids</th>
                    <th scope="col">Pg Details</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((tt, index) => {
                    let ccj = tt.charge ? JSON.parse(tt?.charge) : {};



                    let one = 0;
                    let two = 0;
                    let three = 0;
                    let fouer = 0;
                    let five = 0;

                    let hfg = "";
                    if (tt.pg_res) {
                      hfg = JSON.parse(tt?.pg_res);
                    }

                    tt.pay.map((fff, dataff) => {
                      if (fff.payment_status_msg === "Failed") {
                        one = one + 1;
                      } else if (
                        fff.payment_status_msg === "Processing" &&
                        fff?.freeze != true
                      ) {
                        two = two + 1;
                      } else if (fff.payment_status_msg === "Success") {
                        three = three + 1;
                      } else if (fff.payment_status_msg === "Refund") {
                        fouer = fouer + 1;
                      } else if (fff?.freeze === true) {
                        five = five + 1;
                      }
                    });


                    const parsed = JSON.parse(tt.typevalue);


                    return (
                      <tr style={{ cursor: "pointer" }}>
                        <th
                          scope="row"
                          style={{ marginTop: -18, fontWeight: "700" }}
                        >
                          {index + indexs * 10 + 1}
                        </th>
                        <td
                          onClick={() => {
                            // navigate(
                            //   "/rentdetail",
                            //   { state: tt },
                            //   { merch: JSON.stringify(tt.marchantid[0]) }
                            // );



                            setPikk(true);

                            let aaont = Number(tt.amount);
                            let amm = (1 / 100) * Number(tt.amount);

                            let ggssy = amm * 0.18;

                            setPrepaidfees(amm);
                            setText(ggssy);

                            setFF(tt);








                            setCharge(tt);
                            setDatae(tt?.marchantid[0]);
                            if (tt?.charge != undefined) {
                              setChsrggess(JSON.parse(tt?.charge));
                            }
                            if (tt?.pg_res != undefined) {
                              Setpg_res(JSON.parse(tt?.pg_res));
                            }

                            if (
                              tt?.sms?.length === 0 ||
                              tt?.sms === undefined
                            ) {
                              setSms([]);
                            } else {
                              setSms(JSON.parse(tt?.sms));
                            }

                            tt.pay.map((fff, dataff) => {

                              if (fff.payment_status_msg === "Failed") {
                                let jh = 0;
                                jh = jh + 1;
                                setones(jh);
                              } else if (
                                fff.payment_status_msg === "Processing"
                              ) {
                                let jh = 0;
                                jh = jh + 1;
                                settwos(jh);
                              } else if (fff.payment_status_msg === "Success") {
                                let jh = 0;
                                jh = jh + 1;
                                setthrees(threes + 1);
                              } else if (fff.payment_status_msg === "Refund") {
                                let jh = 0;
                                jh = jh + 1;
                                setfouers(jh);
                              }
                            });

                            // togglePanel(tt);
                          }}
                          style={{
                            backgroundColor:
                              tt?.user?.fraud === true
                                ? "orange"
                                : tt?.user?.marklist === true
                                  ? "#fc97f1"
                                  : "#fff",
                          }}
                        >
                          <div>
                            <p style={{ fontWeight: "600", fontSize: 18 }}>
                              {tt?.user?.name}
                            </p>
                            <p
                              style={{
                                marginTop: -12,
                                fontWeight: "500",
                                color: "#252525B8",
                                fontSize: 16,
                              }}
                            >
                              {tt?.user?.phoneno}
                            </p>
                            <p
                              style={{
                                marginTop: -12,
                                fontWeight: "500",
                                color: "#252525B8",
                                fontSize: 16,
                              }}
                            >
                              {tt?.user?.email}
                            </p>

                             <p
                              style={{
                                marginTop: -12,
                                fontWeight: "500",
                                color: "#ff0000b8",
                                fontSize: 16,
                              }}
                            >
                             WalletAmount :  { tt?.Reward_Wallet === null ? 0 :  tt?.Reward_Wallet === null ?
                             
                             0 :tt?.Reward_Wallet?.amount.toFixed(2)}
                            </p>


                            <div className="d-flex" style={{ marginTop: -12 }}>
                              <div className="d-flex ">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8",
                                    fontSize: 16,
                                    marginRight: 5,
                                  }}
                                >
                                  {" "}
                                  {one}
                                </p>
                                <img
                                  src="on1.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>
                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8",
                                    fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {three}
                                </p>
                                <img
                                  src="on3.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>
                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8",
                                    fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {two}
                                </p>
                                <img
                                  src="on2.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>

                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8",
                                    fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {fouer}
                                </p>
                                <img
                                  src="on4.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>

                              <div className="d-flex">
                                <p
                                  className=" "
                                  style={{
                                    fontWeight: "500",
                                    color: "#252525B8",
                                    fontSize: 16,
                                    marginRight: 5,
                                    marginLeft: 15,
                                  }}
                                >
                                  {" "}
                                  {five}
                                </p>
                                <img
                                  src="on5.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </div>
                            </div>

                            {
                              Number(ccj?.fee) === 0 ?
                              <div style={{ marginTop: 20 }}>
                                <p style={{ color : 'red' , fontWeight : '700' }}>First Payment</p>
                              </div>

                              : ""

                            }

                            

                          </div>
                        </td>

                        <td>
                          <div>
                            <p style={{ fontWeight: "600", fontSize: 18 }}>
                              {tt?.pg}
                            </p>
                            <p
                              style={{
                                marginTop: -12,
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color: "#4F4F4F",
                                }}
                              >
                                {" "}
                                Date :
                              </span>{" "}
                              {convertDateString(tt?.createdAt)}
                            </p>
                            <p
                              style={{
                                marginTop: -12,
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color: "#4F4F4F",
                                }}
                              >
                                Xopay ID :{" "}
                              </span>
                              {tt?.xopay_id}
                            </p>
                            <p
                              style={{
                                marginTop: -12,
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color: "#4F4F4F",
                                }}
                              >
                                PG ID :{" "}
                              </span>
                              {tt?.pg_transactionId}
                            </p>

                          </div>
                        </td>

                        <td>
                          <div>
                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color: "#4F4F4F",
                                }}
                              >
                                Card :{" "}
                              </span>
                              { 
                               hfg?.paymentDetails?.length
                                ? hfg.paymentDetails[0]?.instrument?.cardNetwork
                                : "" }
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color:  hfg?.paymentDetails?.length ? hfg.paymentDetails[0]?.instrument?.type === "CREDIT_CARD" ? "#4F4F4F" : "red" : "red",
                                }}
                              >
                                {" "}
                                Card Type :{" "} 
                              </span>
                               { 
                               hfg?.paymentDetails?.length
                                ? hfg.paymentDetails[0]?.instrument?.type
                                : "" }
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                             
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: 16,
                                  color: "#4F4F4F",
                                }}
                              >
                                Card Number :{" "}
                              </span>
                               { 
                               hfg?.paymentDetails?.length
                                ? hfg.paymentDetails[0]?.instrument?.maskedCardNumber
                                : "" }
                            </p>





                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color:
                                  hfg?.code === "PAYMENT_SUCCESS"
                                    ? "green"
                                    : "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              {hfg?.code || hfg?.status}
                            </p>

                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: "#252525B8",
                                marginTop: -12,
                              }}
                            >
                              {hfg?.message || hfg?.unmappedstatus}
                            </p>


                            <p
                              style={{
                                fontWeight: "500",
                                fontSize: 16,
                                color: parsed?.item?.name === "AMEX" || parsed?.item?.name === "Dynex" ? "red" : "black",
                                marginTop: -12,
                              }}
                            >
                              {parsed?.item?.name}
                            </p>
                          </div>
                        </td>

                        <td>
                          <p style={{ fontWeight: "600", fontSize: 18 }}>
                            Amount : {tt?.amount}
                          </p>

                          <p
                            style={{
                              fontWeight: "500",
                              fontSize: 16,
                              color: "#252525B8",
                              marginTop: -12,
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                fontSize: 16,
                                color: "#4F4F4F",
                              }}
                            >
                              Reward :{" "}
                            </span>
                            - {tt?.reward || 0}
                          </p>
                          <p
                            style={{
                              fontWeight: "500",
                              fontSize: 16,
                              color: "#252525B8",
                              marginTop: -12,
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                fontSize: 16,
                                color: "#4F4F4F",
                              }}
                            >
                              Conv Fee :{" "}
                            </span>
                            {tt?.co_fess}
                          </p>
                          <p
                            style={{
                              fontWeight: "500",
                              fontSize: 16,
                              color: "#252525B8",
                              marginTop: -12,
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                fontSize: 16,
                                color: "#4F4F4F",
                              }}
                            >
                              Conv % :{" "}
                            </span>
                            {ccj?.fee}
                            {" %"}
                          </p>
                          <p
                            style={{
                              fontWeight: "500",
                              fontSize: 16,
                              color: "#252525B8",
                              marginTop: -12,
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                fontSize: 16,
                                color: "#4F4F4F",
                              }}
                            >
                              Gst :{" "}
                            </span>
                            {tt?.gst}
                          </p>

                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: 18,
                              marginTop: -12,
                            }}
                          >
                            Total : {tt?.totalamount}
                          </p>
                        </td>

                        <td>
                          <div>
                            <p
                              style={{
                                color: "#0F3E97",
                                fontWeight: "600",
                                fontSize: "600",
                              }}
                            >
                              Priority : {ccj?.title}
                            </p>

                            <p
                              style={{
                                color:
                                  tt?.payment_status_msg === "Processing" ||
                                    tt?.payment_status_msg === "Progress"
                                    ? "orange"
                                    : tt?.payment_status_msg === "Failed"
                                      ? "red"
                                      : "green",
                                fontWeight: "600",
                                marginTop: -12,
                                fontSize: 16,
                              }}
                            >
                              {tt?.payment_status_msg}
                            </p>

                            {tt?.payment_status_msg === "Processing" ||
                              tt?.payment_status_msg === "Progress" ? (
                              <p style={{ fontWeight: "700", marginTop: -12 }}>
                                {ccj?.title === "T1"
                                  ? newaddWorkingDayt3(1, leave ,  tt?.createdAt  )
                                  : ccj?.title === "Sameday"
                                    ? "4 to 5 hours"
                                    : ccj?.title === "T2"
                                      ? newaddWorkingDayt3(2, leave, tt?.createdAt)
                                      :  ccj?.title === "T4" ? newaddWorkingDayt3(4, leave, tt?.createdAt) : newaddWorkingDayt3(3, leave, tt?.createdAt) }
                              </p>
                            ) : (
                              ""
                            )}


                             { 
                              tt?.payment_status_msg === "Success" ? (
                              <p style={{ fontWeight: "700", marginTop: -12 }}>
                                 settle date : { tt?.status_update_date }
                              </p>
                            ) : (
                              ""
                            )}

                            <div className="d-flex gap-3">
                              <button
                                onClick={() => {
                                  verifyy(tt);
                                }}
                                style={{
                                  color: "#4F4F4F",
                                  width: 100,
                                  height: 30,
                                  borderColor: "#4F4F4F",
                                }}
                              >
                                Verify
                              </button>

                              <button
                                onClick={() => {
                                  Freeze(tt);
                                }}
                                style={{
                                  color: "#4F4F4F",
                                  width: 100,
                                  height: 30,
                                  borderColor: "#4F4F4F",
                                }}
                              >
                                Freeze
                              </button>
                            </div>

                            <div
                              className="d-flex gap-3"
                              style={{ marginTop: 6 }}
                            >
                              {tt?.verified === true ? (
                                <p
                                  style={{
                                    fontWeight: "600",
                                    fontSize: 16,
                                    color: "#0F3E97",
                                  }}
                                >
                                  Verified
                                </p>
                              ) : (
                                ""
                              )}
                              {tt?.freeze === true ? (
                                <p
                                  style={{
                                    fontWeight: "600",
                                    fontSize: 16,
                                    color: "#0F3E97",
                                  }}
                                >
                                  Freezed
                                </p>
                              ) : (
                                ""
                              )}
                            </div>

                            {/* <button
                              onClick={() => {
                                navigate("/rentdetail", { state: tt });
                              }}
                            >
                              View User
                            </button> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserRent_copy;
